module.exports = "<div class=\"layout-column layout-padding animated fadeIn\"><div class=\"list-item\" *ngFor=\"let item of amounts\"><div class=\"layout-row\"><div class=\"flex content\"><div class=\"title\">{{item.timestamp | toLocalDate:'MM/DD/YYYY'}}</div></div><div class=\"flex-nogrow results c-green\" [class.negative-number]=\"item.amount &lt;= 0\">{{ item.amount | currency:'USD':true }}</div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/salaries/timestamped-amounts/timestamped-amounts.component.pug
// module id = 817
// module chunks = 0